<div class="acc-surveys-by-session-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="surveysBySession()"></grid-content>
</div>